import { UnorderedListOutlined } from "@ant-design/icons";

import { TextDOMPurify } from "Services/Sanitization";

import { highlightMatches } from "../helper";

import styles from "./SpotlightRoutingItem.module.scss";

type SpotlightRoutingItemProps = {
    name: string;
    description: string;
    route: string;
    searchValue: string;
    onCallback: () => void;
    icon?: React.ReactNode;
};

export function SpotlightRoutingItem({
    name,
    description,
    route,
    searchValue,
    onCallback,
    icon,
}: SpotlightRoutingItemProps): JSX.Element {
    // `route` may carry a query string used to trigger an action on arrival (e.g.
    // `?sendEvent=1` — see useSpotlightSearchRoutes.tsx's "Send Event" item). That's an
    // implementation detail, not something a user should see as "where this takes you".
    const displayRoute = route.split("?")[0];

    return (
        <div
            className={styles.spotlightItem}
            onClick={() => {
                onCallback();
            }}
        >
            <div>{icon ? icon : <UnorderedListOutlined />}</div>
            <div>
                <div className={styles.routeContainer}>
                    <div
                        className={styles.name}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(searchValue ? highlightMatches(name, searchValue) : name),
                        }}
                    ></div>
                    <div className={styles.route}>{displayRoute}</div>
                </div>
                <div
                    className={styles.description}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: TextDOMPurify.sanitize(
                            searchValue ? highlightMatches(description, searchValue) : description
                        ),
                    }}
                ></div>
            </div>
        </div>
    );
}
